import React from 'react';
import { SystemShared } from '../../../../shared/system';
import { UserDataWeb, UserOrdersWeb } from '../../../../shared/userdataweb';
import { LangBlock } from '../../global';
import { AdminDataTable } from './admin.table';
import { AdminPagination } from './admin.pagination';
import { usePaginatedTable } from './usePaginatedTable';
import { AdminPageWrap, AdminSection } from './admin.ui';

type Props = {
    ordersList: UserOrdersWeb[];
    usersList: UserDataWeb[];
};

export const AdminOrders = ({ ordersList, usersList }: Props) => {
    const [, , LangString] = LangBlock();
    const table = usePaginatedTable(ordersList, 50);

    const userLabel = (id: number) => {
        const rec = usersList.find((q) => q.id === id);

        return rec ? `${rec.name} (${rec.id})` : `${id}`;
    };

    return (
        <AdminPageWrap>
            <AdminSection
                title={LangString('AdminOrdersTitle', ordersList.length)}
                subtitle={LangString('AdminOrdersSubtitle')}
            >
                <AdminDataTable
                    data={table.pageData}
                    sortColumn={table.sortColumn}
                    sortType={table.sortType}
                    onSort={table.handleSort}
                    rowKey={(row) => row.id}
                    emptyMessage={LangString('AdminNoOrders')}
                    columns={[
                        {
                            key: 'id',
                            label: LangString('AdminId'),
                            sortable: true,
                            primary: true,
                            render: (row) => `#${row.id}`,
                        },
                        {
                            key: 'type',
                            label: LangString('AdminType'),
                            render: (row) => row.type,
                        },
                        {
                            key: 'endSeconds',
                            label: LangString('AdminRemaining'),
                            render: (row) =>
                                row.endSeconds === -1
                                    ? LangString('AdminLifetime')
                                    : SystemShared.secondsToString(row.endSeconds),
                        },
                        {
                            key: 'user',
                            label: LangString('AdminUser'),
                            render: (row) => userLabel(row.user),
                        },
                        {
                            key: 'hwid',
                            label: LangString('AdminHwid'),
                            render: (row) => row.hwid || '—',
                        },
                    ]}
                />
                <AdminPagination
                    page={table.page}
                    totalPages={table.totalPages}
                    total={table.total}
                    limit={table.limit}
                    limitOptions={[10, 30, 50, 100, 500, 1000, 10000]}
                    onPageChange={table.setPage}
                    onLimitChange={table.setLimit}
                />
            </AdminSection>
        </AdminPageWrap>
    );
};
